/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_TitleInputs */

const en_guide_json_schema_title = /** @type {(inputs: Guide_Json_Schema_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema: Validate Your Data Structure: PureJSON`)
};

const ko_guide_json_schema_title = /** @type {(inputs: Guide_Json_Schema_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema: 데이터 구조 유효성 검사: PureJSON`)
};

const ja_guide_json_schema_title = /** @type {(inputs: Guide_Json_Schema_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema：データ構造を検証する: PureJSON`)
};

/**
* | output |
* | --- |
* | "JSON Schema: Validate Your Data Structure: PureJSON" |
*
* @param {Guide_Json_Schema_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_title = /** @type {((inputs?: Guide_Json_Schema_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_title(inputs)
	if (locale === "ko") return ko_guide_json_schema_title(inputs)
	return ja_guide_json_schema_title(inputs)
});